import { useAppSelector } from '../../../global/hooks';
import useCanAddSection from '../../../hooks/useCanAddSection';
import { selectMode, setView } from '../../../store/appSlice';
import { BottomSpacer, ButtonAddon, ButtonAddonShape, StyledAddButton } from './styles';
import { useDispatch } from 'react-redux';

interface Props {
	hasNoSections: boolean;
}

export default function AddSectionButton({ hasNoSections }: Props) {
	const dispatch = useDispatch();
	const mode = useAppSelector(selectMode);
	const [canAddSection, reasons] = useCanAddSection();
	const addSection = () => {
		if (canAddSection) {
			dispatch(setView('editSection'));
		} else {
			// @TODO warning modal
			console.warn(reasons.join(', '));
		}
	};
	return mode === 'edit' ? (
		<>
			<StyledAddButton
				className="add-section-button"
				disabled={!canAddSection}
				hasNoSections={hasNoSections}
				onClick={addSection}
				title={canAddSection ? 'Add section' : reasons.join(', ')}
				aria-label="Add section"
			>
				+{' '}
				{hasNoSections && (
					<ButtonAddon>
						<ButtonAddonShape />
						Add Section
					</ButtonAddon>
				)}
			</StyledAddButton>
		</>
	) : (
		<BottomSpacer />
	);
}
